import script from "./form-item-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-item-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./form-item-wrap.vue?vue&type=style&index=0&id=21fcdc1d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21fcdc1d"]])

export default __exports__